<template>
  <div class="contact-button" v-if="showButton">
    <a href="mailto:suporte@blitzpay.com.br" class="contact-link">
      <svg
        :width="getSize"
        :height="getSize"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="12" cy="12" r="12" fill="#2196F3"/>
        <path
          d="M6 8.5C6 7.67157 6.67157 7 7.5 7H16.5C17.3284 7 18 7.67157 18 8.5V15.5C18 16.3284 17.3284 17 16.5 17H7.5C6.67157 17 6 16.3284 6 15.5V8.5Z"
          stroke="white"
          stroke-width="1.5"
          fill="none"
        />
        <path
          d="M6 8.5L12 12.5L18 8.5"
          stroke="white"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <span v-if="showLabel" class="contact-label">Fale Conosco</span>
    </a>
  </div>
</template>

<script>
export default {
  props: {
    size: {
      type: String,
      default: "small"
    },
    showLabel: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  computed: {
    getSize() {
      return this.size === "large" ? "32" : "30";
    },
    showButton() {
      return document.location.href.indexOf("app") > 0;
    }
  },

  mounted() {},

  methods: {}
};
</script>

<style scoped>
.contact-button {
  display: inline-flex;
  align-items: center;
}

.contact-link {
  display: flex;
  align-items: center;
  gap: 8px;
  text-decoration: none;
  color: inherit;
  transition: opacity 0.2s ease;
}

.contact-link:hover {
  opacity: 0.8;
}

.contact-label {
  font-size: 14px;
  font-weight: 500;
  color: #2196F3;
  white-space: nowrap;
}
</style>
